import Base_config from '@/config/base-config'
import { routeHasExist,routeEqual} from "@/lib/util";
import { homeRoute } from "@/router/routes";
import commonFun from "@/lib/commonFun";

//关闭标签后自动跳转到下一页
const getNextPage = (pageList,closePage) => {
  let res = {}
  // 根据用户组ID决定默认首页
  const groupID = parseInt(sessionStorage.getItem('groupID')) || 0;
  const defaultHomeRoute = groupID === 3 
    ? { path: '/dashboard', name: '工作台', meta: { title: '工作台', notCache: true, icon: 'md-home' } }
    : {...homeRoute};
  
  if (pageList.length === 2) {    //只有两个标签关闭一个后则跳转首页
    res = defaultHomeRoute
  } else {
    const index = pageList.findIndex(item => routeEqual(item, closePage))
    if (index === pageList.length - 1){         //如果关闭的是最后一页，则打开倒数第二页
      res = pageList[pageList.length - 2]
    } else{
      res = pageList[index + 1]
    }
  }
  return res
}

//获取当前已经打开的页面
const getOpenedPage = function() {
  let storage = sessionStorage.getItem('openedPage');
  if (storage) {
    return JSON.parse(storage);
  }
  // 根据用户组ID决定默认首页
  const groupID = parseInt(sessionStorage.getItem('groupID')) || 0;
  if (groupID === 3) {
    // 合伙人使用 dashboard
    return [{ path: '/dashboard', name: '工作台', meta: { title: '工作台', notCache: true, icon: 'md-home' } }];
  }
  // 其他角色使用 home
  return [{...homeRoute}];
}

export default {
  namespaced: true,
  state: {
    headerBreadCrumb: [],         //顶部 路由导航面包屑,首页固定放在第一个
    openedPage: getOpenedPage(),      //顶部导航菜单栏,当前打开的页面（动态初始化）
    isAddRoute: false,            //是否已经添加了动态路由，用于刷新页面时判断是否需要再处理动态路由
  },
  getters: {

  },
  mutations: {
    /**
     * 设置首页当前路由面包屑
     * @param state
     * @param currentRoute 当前路由
     * @returns {{icon: *}[]|*[]}
     */
    setBreadCrumb(state,currentRoute){
      // 根据用户组ID决定默认首页
      const groupID = parseInt(sessionStorage.getItem('groupID')) || 0;
      const defaultHomeRoute = groupID === 3 
        ? { path: '/dashboard', name: '工作台', meta: { title: '工作台', notCache: true, icon: 'md-home' } }
        : {...homeRoute};
      
      let homeItem = { icon: defaultHomeRoute.meta.icon,name: defaultHomeRoute.name,title: defaultHomeRoute.meta.title,to: defaultHomeRoute.path }
      let routeMatched = currentRoute.matched
      //如果跳转页面是首页
      if (routeMatched.some(item => item.name === defaultHomeRoute.name)){
        return state.headerBreadCrumb = [homeItem]
      }
      let res = routeMatched.filter(item => {
        return item.meta === undefined || !item.meta.hideInBread || !item.meta.hideInMenu
      }).map(item => {
        return {
          icon: (item.meta && item.meta.icon) || '',
          name: item.name,
          title: (item.meta && item.meta.title) || item.name,
        }
      })
      return state.headerBreadCrumb = [homeItem, ...res]
    },
    setIsAddRoute:(state) => {
      state.isAddRoute = true
    },
    setOpenedPage: (state,openedPage) => {
      sessionStorage.setItem('openedPage',JSON.stringify([...openedPage]))
      state.openedPage = openedPage
    }
  },
  actions: {
    /**
     * 添加或删除打开的页面标签,将信息缓存
     * @param commit
     * @param route 当前操作的路由
     * @param type open|close  操作类型,打开或者关闭
     * @param isCurrent 是否是当前路由
     * @returns {*|void}
     */
    changeOpenedPage: ({commit} ,{route, type='open',isCurrent} ) => {
      let openedPage = getOpenedPage()
      let has_exist = routeHasExist(openedPage,route)
      //首页是固定的不能添加或删除
      /*if(route.name && route.name === Base_config.HOME_PAGE){
        return commit('setOpenedPage',[{...homeRoute}])
      }*/
      if(type === 'open' && !has_exist){
        openedPage.push(route)
      }else if(type === 'close' && has_exist){
        //关闭的是当前页面则跳转到下一页
        if (isCurrent){
          let nextPage = getNextPage(openedPage,route)
          commonFun.jumpTo('',nextPage.name)
        }
        openedPage = openedPage.filter( (val) =>{
          return !routeEqual(val,route)
        })
      }
      return commit('setOpenedPage',openedPage)
    },

    /**
     * 关闭所有或其他页面
     * @param commit
     * @param type   close_all 关闭所有|close_other 关闭其他
     * @param currentRoute 当前路由
     */
    closeOpenedPage: ({commit},{type,currentRoute}) => {
      let openedPage = [];
      // 根据用户组ID决定默认首页
      const groupID = parseInt(sessionStorage.getItem('groupID')) || 0;
      const defaultHomeRoute = groupID === 3 
        ? { path: '/dashboard', name: '工作台', meta: { title: '工作台', notCache: true, icon: 'md-home' } }
        : {...homeRoute};
      
      if (type === 'close_all'){
        openedPage = [defaultHomeRoute]
        commonFun.jumpTo('', defaultHomeRoute.name)
      }else if (type === 'close_others'){
        openedPage = [defaultHomeRoute,{...currentRoute}]
      }
      commit('setOpenedPage',openedPage)
    },

  }

}
